import { useFlags } from 'launchdarkly-react-client-sdk';
import { HRISProviderSlugEnum } from '@electricjs/core_entity-client';
import { useAppSelector } from '@/redux/store';

const ADP_PROVIDER_SLUGS: string[] = [
  HRISProviderSlugEnum.AdpR,
  HRISProviderSlugEnum.AdpWfn,
  HRISProviderSlugEnum.AdpWfnNg,
  HRISProviderSlugEnum.AdpWfnCanada,
  HRISProviderSlugEnum.AdpWfnTotalSource,
];

// Every call site of this hook only exists to gate fr-CA job title/group name
// display, so the flag lives here rather than being re-checked at each site.
export const useIsAdpWfnCanadaConnectedOrg = () => {
  const HRISProviderSlug = useAppSelector(
    state => state.loggedUser?.organizationHrisIntegration?.hrisProvider.slug
  );
  const { ithFrCaJobTitlesAndGroupNames } = useFlags();
  return (
    !!HRISProviderSlug &&
    ADP_PROVIDER_SLUGS.includes(HRISProviderSlug) &&
    ithFrCaJobTitlesAndGroupNames
  );
};
